import { addItemToCollection } from "directus/src/operations";

// Add createProject function
export async function createOpeningInterview({ item }) {
    try {
        const query = {
            fields: [
                "id",
                "applicant",
                "date_scheduled",
                "title",
                "recording_url",
                "status",
                "client_feedback",
                "internal_feedback",
                "transcript",
                "is_cleared",
            ],
        };

        const data = await addItemToCollection("opening_interviews", item, query);

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
